<div class="ui-g">
    <div class="ui-g-12">
        <p-menu #adminmenu [popup]="true" [model]="items"></p-menu>
        <button class="ui-button-secondary show-menu menu-button" type="button" pButton icon="pi pi-list"
            (click)="adminmenu.toggle($event)"></button>
        <h2 class="section-header">{{ 'admin_panel' | translate }}</h2>
    </div>
</div>
<div class="ui-g">
    <div class="ui-sm-0 ui-md-0 ui-lg-2 ui-xl-2 hide-menu">
        <p-menu #menu [model]="items" (click)="menu.toggle($event)"></p-menu>
    </div>
    <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-10" style="overflow-y: auto;">
        <router-outlet></router-outlet>
    </div>
</div>